import React from "react";
import styles from "./app-button.module.scss";

export type AppButtonProps = {
  brand: AppButtonBrand;
  size: AppButtonSize;
  theme: AppButtonTheme;
} & React.HTMLAttributes<HTMLAnchorElement>;

type AppButtonBrand = "Apple Store" | "Google Play";

type AppButtonSize = "large" | "default" | "small";

type AppButtonTheme = "light" | "dark";

const appStoreUrl =
  "https://apps.apple.com/us/app/camp-gladiator/id648465971?itsct=apps_box&amp;itscg=30200";

const googlePlayStoreUrl =
  "https://play.google.com/store/apps/details?id=com.campgladiator&hl=en_US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";

const AppButton = ({
  brand,
  size,
  theme,
  className = "",
  ...props
}: AppButtonProps) => {
  const link = brand === "Google Play" ? googlePlayStoreUrl : appStoreUrl;

  return (
    <a
      href={link}
      className={`${styles.appButton} ${className}`}
      target="_blank"
      data-brand={brand}
      data-size={size}
      data-theme={theme}
      {...props}
    >
      {brand}
    </a>
  );
};

export default AppButton;
